<template>
  <!-- <div class="app-wrapper" :class="classObj">
     <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>
     <sidebar class="sidebar-container"></sidebar>
     <div class="main-container">
       <navbar></navbar>
       <tags-view></tags-view>
       <app-main></app-main>
     </div>
   </div> -->
  <div class="app-wrapper" :class="classObj">
    <el-container class="flex-column">
      <el-header height="44px">
        <navbar></navbar>
      </el-header>
      <el-container class="flex-row flex-item">
        <sidebar class="sidebar-container"></sidebar>
        <div class="main-container flex-item">
          <tags-view class="custom-tags-view"></tags-view>
          <app-main></app-main>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { mapGetters } from 'vuex';
// import { postMessageByUser } from '@/api/users'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    },
    ...mapGetters(['name', 'usid'])
  },
  created() {
    // 这里Show就是在服务端指定的Show的方法名称，这里是先清除，再加上
    // this.signalr.off('Show')
    // this.signalr.on('Show', res => {
    //   // 可以做相关业务逻辑
    //   this.$notify.info({
    //     title: '消息通知',
    //     position: 'bottom-right',
    //     message: res,
    //     duration: 0
    //   })
    // })
  },
  mounted() {
    // this.signalr.start().then(() => {
    //   // console.log('连接')
    //   this.signalr.invoke('Register', this.usid)
    //   postMessageByUser()
    // })
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('CloseSideBar', { withoutAnimation: false });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/mixin.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.el-header {
  padding: 0;
  line-height: 44px;
  background-color: #333;
  // position: fixed;// me
  // top: 0;// me
  width: 100%;
  z-index: 100;
}

.el-container .sidebar-container {
  // top: 44px !important;
  height: auto !important;

  // position: relative !important;// me
}

.el-container .main-container {
  margin-left: 0 !important;
  overflow: hidden;
}

.custom-tags-view {
  margin-top: 0 !important;
}
</style>
